svg.externalLink {
	@apply yst-inline-block yst-max-w-3.5 yst-h-3.5 yst-ml-1.5 yst-text-slate-500 #{!important};
}
